export const PROJECT_FEATURE_KEY = 'project';
